import React, { useState } from 'react'

// Mui
import {
  Radio,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Box,
} from '@material-ui/core'

// Util
import { Observer } from 'mobx-react'
import _toArray from 'lodash/toArray'
import _size from 'lodash/size'

// My util
import useStyles from './AccountList.styles'
import { useStores } from 'config/store'
import SearchBar from './SearchBar'
import notificationSettingsStore from 'config/store/NotificationSettingsStore'

const AccountList = () => {
  const classes = useStyles()
  const { notificationSettingsStore } = useStores()
  const [searchTerm, setSearchTerm] = useState('')

  const filteredAccounts = !searchTerm
    ? notificationSettingsStore.accounts
    : _toArray(notificationSettingsStore.accounts).filter((account) => {
        if (!searchTerm) {
          return true
        }
        const matchesSearch = account.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
        return matchesSearch
      })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    notificationSettingsStore.setPendingSelectedAccount(
      (event.target as HTMLInputElement).value
    )
  }
  return (
    <Observer
      render={() => {
        return (
          <div className={classes.root}>
            <Box className={classes.sticky}>
              <Box sx={{ width: '100%' }}>
                <SearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                />
              </Box>
            </Box>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="account"
                name="account"
                value={notificationSettingsStore.pendingSelectedAccount}
                onChange={handleChange}
              >
                {filteredAccounts.map(
                  (account: any, index: number) => {
                    return (
                      <FormControlLabel
                        key={`${account.id}--${index}`}
                        value={account.id}
                        classes={{
                          root: classes.listText,
                          label: classes.listTextPrimary,
                        }}
                        control={<Radio color="primary" value={account.id} />}
                        label={account.name}
                        labelPlacement="end"
                      />
                    )
                  }
                )}
              </RadioGroup>
            </FormControl>
          </div>
        )
      }}
    />
  )
}

export default AccountList
